import React, { useEffect } from "react";
import ScrollToTop from "./components/ScrollToTop";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Services from "./components/Services";
import Recommend from "./components/Recommend";
import AboutUs from "./components/AboutUs";
import Testimonials from "./components/Testimonials";
import Footer from "./components/Footer";
import scrollreveal from "scrollreveal";

const App = () => {
	useEffect(() => {
		const sr = scrollreveal({
			origin: "top",
			distance: "80px",
			duration: 1000,
			reset: true,
		});
		sr.reveal(
			`
        nav,
        #hero,
        #services,
        #aboutus,
        #recommend,
        #testimonials,
        #footer
        `,
			{
				opacity: 0,
				interval: 300,
			}
		);
	}, []);

	return (
		<>
			<ScrollToTop />
			<Navbar />
			<Hero />
			<Services />
			<Recommend />
			<AboutUs />
			<Testimonials />
			<Footer />
		</>
	);
};

export default App;
